import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    "__schema": {
      "types": [
        {
          "kind": "UNION",
          "name": "SearchResult",
          "possibleTypes": [
            {
              "name": "Person"
            },
            {
              "name": "Descriptor"
            },
            {
              "name": "ListQueryResult"
            }
          ]
        },
      ]
    }
  }
})

// TODO should be export default
export const client = new ApolloClient({
  link: createHttpLink({
    uri: '/graphql',
    credentials: 'include',
  }),
  cache: new InMemoryCache({
    fragmentMatcher,
    dataIdFromObject: ({ uuid }) => uuid }),
  defaultOptions: {
    query: {
      // TODO This doesn't work, probably apollo bug
      fetchPolicy: 'cache-and-network',
    }
  }
})



// WEBPACK FOOTER //
// ./src/config.js